import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import ProjectAdminHeader from "./components/header/ProjectAdminHeader";
import ProjectAdminSidebar from "./components/sidebar/ProjectAdminSidebar";
import { ClientStatusProvider } from "../../views/context/clientContext";
import { HeaderSlotProvider } from "../../contexts/HeaderSlotContext";
// import brandMark from "../../assets/img/serviceloom-mark-blue.svg";

// Shared canvas: #E9F0FE base with a top-right radial glow (#4C35D7 → transparent).
// Matches the Figma spec: 1145x1203 ellipse, top -92px, positioned off the right edge.
const CANVAS_BG =
  "radial-gradient(ellipse 711px 1111px at 100% 25%, rgba(76, 53, 215, 0.4) 0%, rgba(233, 240, 254, 0) 70%), #E9F0FE";

// ---- Route label helper ----
const getCurrentRoute = (pathname) => {
  const routeMap = {
    "/tickets": "Tickets",
    "/launchpad": "Launchpad",
    "/overview": "Overview",
    "/queues": "Queues",
    "/knowledge-base": "Knowledge Base",
    "/profile": "Profile",
  };

  // DEF-114: detail lives under /tickets/:id and now also /incidents/:id and
  // /requests/:id (section-scoped so the sidebar stays highlighted). Match the
  // detail form (a trailing id segment), not the bare list routes.
  if (pathname.includes("/tickets/") || /\/(incidents|requests)\/[^/]+$/.test(pathname)) return "Ticket Details";
  if (pathname.includes("/knowledge-base/setup")) return "Knowledge Base Setup";
  if (pathname.includes("/knowledge-base/create-knowledge-base") || pathname.includes("/launchpad/create-knowledge-base")) return "Create Article";
  if (pathname.includes("/knowledge-base/bulk-upload-knowledge-base")) return "Bulk Upload KB";
  if (pathname.includes("/knowledge-base/article/")) return "Article Preview";
  if (pathname.includes("/agents/edit-agent/")) return "Edit Agent";
  if (pathname.includes("/agents/")) return "Agent Summary";
  if (pathname.includes("/queues/view/")) return "Queue Summary";
  if (pathname.includes("/queues/create-assign-queue") || pathname.includes("/launchpad/create-assign-queue")) return "Create & Assign Queue";
  if (pathname.includes("/queues/edit-assign-queue/")) return "Edit Queue";
  if (pathname.includes("/profile-setup")) return "Profile Setup";
  if (pathname.includes("/CustomForm")) return "Custom Form";

  for (const [path, name] of Object.entries(routeMap)) {
    if (pathname.includes(path)) return name;
  }

  return "Launchpad";
};

export default function ProjectAdminLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const currentRoute = React.useMemo(
    () => getCurrentRoute(location.pathname),
    [location.pathname]
  );

  return (
    <ClientStatusProvider>
      <HeaderSlotProvider>
        <div
          className="flex h-screen w-full overflow-hidden"
          style={{
            background: CANVAS_BG,
            backdropFilter: "blur(90px)",
            WebkitBackdropFilter: "blur(90px)",
          }}
        >

          {/* Sidebar */}
          <ProjectAdminSidebar
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />

          {/* Main Section */}
          <div className="flex flex-col flex-1 h-[100%] overflow-hidden relative">

            {/* Brand mark — top-left accent */}
            {/* <img
              src={brandMark}
              alt="ServiceLoom"
              className="absolute top-4 left-4 w-6 h-6 pointer-events-none z-20 hidden md:block"
            /> */}

            {/* Header */}
            <ProjectAdminHeader
              currentRoute={currentRoute}
              onOpenSidenav={() => setSidebarOpen(true)}
            />

            {/* Page Content */}
            <main className="flex-1 min-h-0 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="w-full px-5 pb-5 pt-3 min-h-full flex flex-col">
                <Outlet />
              </div>
            </main>

          </div>
        </div>
      </HeaderSlotProvider>
    </ClientStatusProvider>
  );
}